import { ModuleWithProviders, NgModule } from "@angular/core";


export { ISystemConfiguration, ISystemConfigurationDetails } from "./interfaces/interfaces";
export { SystemConfigurationService } from "./services/system.configuration.service";

@NgModule({})
export class SystemConfigurationModule{
	public static forMainAppRoot():ModuleWithProviders<SystemConfigurationModule> {
		return {
			ngModule: SystemConfigurationModule,
			providers: [
				// SystemConfigurationPreLoginService,
				// SystemConfigurationProxy
			]
		};
	}

	public static forSessionRoot():ModuleWithProviders<SystemConfigurationModule>{
		return {
			ngModule: SystemConfigurationModule,
			providers: [
				//SystemConfigurationProxy,
				//SystemConfigurationValues,
				//SystemConfigurationService
			]
		};
	}
}

